'use client';

import { createContext, useContext } from 'react';

const EnvContext = createContext({});

export default function EnvProvider({ children, env }) {
  return <EnvContext.Provider value={env}>{children}</EnvContext.Provider>;
}

export const useEnv = () => useContext(EnvContext);
